import classNames from 'classnames';
import './style.scss';

export function AnimatedWritingDots({
  size = 4,
  color = 'neutral',
  revert = false,
}: {
  size?: number;
  color?: string;
  revert?: boolean;
}) {
  return (
    <div
      className={classNames('is-writing-message-dots flex items-center gap-1', {
        'flex-row-reverse': revert,
      })}
    >
      <div
        className={`is-writing-dot rounded-full bg-${color}-300`}
        style={{ width: size + 'px', height: size + 'px' }}
      ></div>
      <div
        className={`is-writing-dot rounded-full bg-${color}-400`}
        style={{ width: size + 'px', height: size + 'px' }}
      ></div>
      <div
        className={`is-writing-dot rounded-full bg-${color}-500`}
        style={{ width: size + 'px', height: size + 'px' }}
      ></div>
    </div>
  );
}
